export const CENTRAL_STATION = 'central_station';
export const RAPIDSOS_PORTAL = 'rapidsos_portal';
export const EMERGENCY_DATA = 'emergency_data';
export const AUTHENTICATION = 'authentication';
export const CAPSTONE = 'capstone';
export const INCIDENT_CENTRAL_STATION = 'incident_central_station';
export const ARCHIVE_VIEW = 'archive_view';
